import { render, staticRenderFns } from "./m-meetingscene.vue?vue&type=template&id=0b95ba7c&scoped=true"
import script from "./m-meetingscene.vue?vue&type=script&lang=js"
export * from "./m-meetingscene.vue?vue&type=script&lang=js"
import style0 from "./m-meetingscene.vue?vue&type=style&index=0&id=0b95ba7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b95ba7c",
  null
  
)

export default component.exports